import { OutputData } from '@editorjs/editorjs'

import { HERO_TYPE_ENUM } from './ambulance'
import { IBase, IBasePublishable } from './base'
import { IPriceListItem } from './price-list'

export enum PRICE_GROUP_TYPE_ENUM {
	GROUP = 'group',
	SERVICE = 'service'
}

export enum PRICE_GROUP_ITEM_FORM_TYPE_ENUM {
	NONE = 'none',
	CONTACT_FORM = 'formobjednaj'
}

export interface IPriceListGroup extends IBase, IBasePublishable {
	name: string
	type: PRICE_GROUP_TYPE_ENUM
	slug: string | null
	text: OutputData
	items: IPriceListItem[]
	sortOrder?: number
	heroText: string | null
	heroTitle: string | null
	heroType: HERO_TYPE_ENUM | null
	_uuid?: string
}
